import dayjs from "dayjs";

const getUnixTimestamp = (date: Date | string) => dayjs(date).unix();

const formatDate = (date: Date | string, format: string) => dayjs(date).format(format);

export { getUnixTimestamp, formatDate };